export function infoImageSlider() {
    const $imageSlider = $(".info-image-slider");
    const $listItem = $(".info-list").find("li");
    const $listItemContent = $(".info-list").find("li .content");
    $imageSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        fade: true,
        dots: false,
        swipe: false
    });
    $listItem.on("click", function () {
        const $currentItem = $(this);
        const $currentitemContent = $currentItem.find(".content");
        const $index = $currentItem.index();
        $currentItem.addClass("active").siblings().removeClass("active");
        $currentitemContent.slideDown(200);
        $listItemContent.not($currentitemContent).slideUp(200);
        $currentItem.parents(".info-block").find($imageSlider).slick("slickGoTo", $index);
    });
    $($listItem[0]).addClass("active");
    $($listItem[0]).find(".content").slideDown(10);
}



// WEBPACK FOOTER //
// ./assets/js/modules/infoImageSlider.js